import { Container, Row, Col } from "reactstrap";

import {
    TrendingUp,
    WorkspacePremium,
    School,
    ArrowForward,
    CheckCircle
} from "@mui/icons-material";

import "./CAD_Career_Advantages.css";


function CADCareerAdvantages({
    title = "Why Learn CAD Automation & Customization?",
    subtitle = "",
    advantages = []
}) {

    const defaultAdvantages = [
        {
            title: "High Salary",
            icon: <TrendingUp />,
            accent: "salary",
            content: (
                <>
                    <p>
                        CAD Design Engineers with 4–5 years of experience
                        typically earn a CTC between ₹5–10 lakh.
                    </p>

                    <p>
                        <strong>However,</strong> CAD Developers with the
                        same experience often earn ₹20–40 lakh.
                        Their skills are rare, so companies pay more.
                    </p>
                </>
            )
        },

        {
            title: "Good Demand",
            icon: <WorkspacePremium />,
            accent: "demand",
            content: (
                <>
                    <p>
                        <strong>While</strong> CAD Design is a familiar
                        skill among mechanical engineers, it’s also
                        highly competitive.
                    </p>

                    <p>
                        <strong>In contrast,</strong> CAD Automation &
                        Customization is a niche domain with limited
                        skilled professionals — making it a high-demand,
                        low-supply opportunity.
                    </p>
                </>
            )
        },

        {
            title: "Easier To Learn",
            icon: <School />,
            accent: "learning",
            content: (
                <>
                    <p>
                        <strong>CAD design is easy to start.</strong>
                    </p>

                    <p>
                        <strong>CAD automation is what makes you stand out.</strong>
                    </p>

                    <p>
                        Our online training makes it simple with
                        hands-on projects and expert support.
                    </p>
                </>
            )
        }
    ];


    const items =
        advantages.length > 0
            ? advantages
            : defaultAdvantages;


    return (

        <section className="cad-career-advantages">

            <Container>

                {/* =====================================
                    HEADER
                ===================================== */}

                <Row className="justify-content-center">

                    <Col lg="9">

                        <div className="cad-advantages-header text-center">

                            <span className="cad-advantages-badge">

                                <span className="cad-advantages-dot"></span>

                                CAREER ADVANTAGE

                            </span>


                            <h2>
                                {title}
                            </h2>


                            <div className="cad-advantages-divider">

                                <span></span>
                                <span></span>
                                <span></span>

                            </div>


                            {subtitle && (

                                <p>
                                    {subtitle}
                                </p>

                            )}

                        </div>

                    </Col>

                </Row>


                {/* =====================================
                    CARDS
                ===================================== */}

                <Row className="g-4">

                    {items.map((item, index) => (

                        <Col
                            lg="4"
                            md="6"
                            key={index}
                        >

                            <article
                                className={`cad-advantage-card ${item.accent || ""}`}
                            >

                                {/* Top */}

                                <div className="cad-advantage-card-top">

                                    <div className="cad-advantage-icon">
                                        {item.icon}
                                    </div>

                                    <span className="cad-advantage-number">
                                        {String(index + 1).padStart(2, "0")}
                                    </span>

                                </div>


                                {/* Title */}

                                <h3>
                                    {item.title}
                                </h3>


                                {/* Content */}

                                <div className="cad-advantage-content">
                                    {item.content}
                                </div>


                                {/* Bottom */}

                                <div className="cad-advantage-bottom">

                                    <div className="cad-advantage-check">
                                        <CheckCircle />
                                    </div>

                                    <span>
                                        Build a specialized career
                                    </span>

                                    <ArrowForward className="cad-advantage-arrow" />

                                </div>

                            </article>

                        </Col>

                    ))}

                </Row>

            </Container>

        </section>
    );
}


export default CADCareerAdvantages;